// front/src/utils/messages.js

export const messages = {
  // ========== УВЕДОМЛЕНИЯ О ЗАПИСИ (TOAST) ==========
  booking: {
    success: '✅ Заявка успешно отправлена! Мы свяжемся с вами для подтверждения.',
    error: '❌ Ошибка при отправке заявки. Попробуйте позже.',
    networkError: '❌ Ошибка соединения с сервером. Проверьте интернет.',
    missingFields: '❌ Пожалуйста, заполните все обязательные поля',
    noDateOrTime: '⚠️ Пожалуйста, выберите дату и время',
    timeAlreadyBooked: (time) => `⏰ Время ${time} уже занято! Выберите другое.`,
    bookingFailed: '❌ Не удалось забронировать. Попробуйте еще раз.',
    cancelConfirm: '❌ Вы уверены, что хотите отменить запись?',
    cancelSuccess: '✅ Запись успешно отменена',
    cancelError: '❌ Ошибка при отмене записи',
    cancelTooLate: (hours, minutes) => `❌ Отмена записи возможна не менее чем за 12 часов до тренировки. До начала осталось ${hours} ч ${minutes} мин.`,
    bookingNotFound: '❌ Запись не найдена',
  },

  // ========== УВЕДОМЛЕНИЯ О СЕРТИФИКАТАХ (TOAST) ==========
  certificate: {
    success: '✅ Заявка на сертификат успешно отправлена! Мы свяжемся с вами.',
    error: '❌ Ошибка при отправке заявки на сертификат',
    minNominal: '⚠️ Минимальный номинал сертификата - 500 ₽',
    selectNominal: '⚠️ Пожалуйста, выберите номинал сертификата',
  },

  // ========== УВЕДОМЛЕНИЯ О ДОСТУПНОСТИ (TOAST) ==========
  availability: {
    dateUnavailable: (month, day) => {
      const months = {
        4: 'май',
        5: 'июнь',
        6: 'июль',
        7: 'август',
        8: 'сентябрь',
        9: 'октябрь',
        10: 'ноябрь',
        11: 'декабрь'
      };
      return `📅 Запись на ${months[month] || 'этот месяц'} временно недоступна. Запись принимается до 15 мая 2026.`;
    },
    noAvailableSlots: '⏰ На выбранную дату нет свободного времени',
    slotsLoadingError: '⚠️ Ошибка загрузки доступного времени',
  },

  // ========== БЛОКИРОВКА ЗАПИСИ (ПО МЕСЯЦАМ/ДАТАМ) ==========
  bookingBlock: {
    mayClosed: (day) => `📅 Запись на май временно недоступна. Откроется до 27 мая 2026.`,
    monthClosed: (monthName, prevMonthName) => 
      `📅 Запись на ${monthName} временно недоступна. Откроется в конце ${prevMonthName}. Следите за новостями!`,
    yearClosed: (year) => `📅 Запись на ${year} год временно недоступна.`,
    default: '📅 Запись на этот месяц временно недоступна.',
  },

  // ========== ИНФОРМАЦИОННЫЕ БАННЕРЫ (ПОСТОЯННЫЕ) ==========
  infoBanner: {
    bookingLimit: '📅 Запись на май 2026 принимается до 15 мая включительно.',
    bookingClosed: '📅 Запись на май 2026 уже закрыта. Следующие месяцы пока недоступны.',
    juneLimit: '📅 Запись на июнь 2026 откроется 16 мая.',
    julyLimit: '📅 Запись на июль 2026 откроется 16 июня.',
  },

  // ========== ВАЛИДАЦИЯ ФОРМ ==========
  validation: {
    required: 'Поле обязательно для заполнения',
    invalidPhone: 'Введите корректный номер телефона',
    invalidEmail: 'Введите корректный email',
  },

  // ========== PWA УВЕДОМЛЕНИЯ ==========
  pwa: {
    updateAvailable: '🔄 Доступна новая версия приложения. Обновите страницу.',
    updateNow: 'Обновить',
    serviceWorkerRegistered: '✅ Приложение готово к работе офлайн',
    notificationsEnabled: '🔔 Уведомления включены!',
    notificationsDisabled: '🔕 Уведомления отключены. Разрешите их в настройках браузера.',
  },

  // ========== ОБЩИЕ ==========
  general: {
    loading: 'Загрузка...',
    error: 'Произошла ошибка. Попробуйте позже.',
    success: 'Успешно!',
    close: 'Закрыть',
    save: 'Сохранить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
  },
};

export default messages;